import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'acl-register-successful',
  standalone: false,
  templateUrl: './register-successful.component.html',
  styleUrl: './register-successful.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterSuccessfulComponent {
  private readonly router = inject(Router);

  @Output() readonly slideTo = new EventEmitter();

  goToLogin(): void {
    this.router.navigate(['/dashboard']);
  }
}
